import http from '@/utils/http';

// 搜索
export const searchCountry = (params) => {
    return http.request({
        url: '/v1/ballsports/base/country/search',
        method: 'post',
        data: params
    })
}